module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABRCAYAAABFTSEIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEdSURBVHgB7dvBTcNAEEDRMR3QAR1ACZRAKekk6SCUQAmUABWEDijBbLiAFFtea4ZIIe9JI198+lrNwVpHAAAAAADXYogLN47jY3vct7lt8zIMw1vQp8Xbjqe2wbIWaj/O2wTzFuIdHYJpHfG+Bad64zmBE1bEO7IDf1sZ7zn4IV6CeAniJYiXIF6CeAniJYiXIF6CeAniJYiXIF6CeAktyEa8hBblIF5CZ7yL+xR/E+fz0fHOXYu4D06t3IEiTjnuNxGTRCwgYgERC4hYQMQCIhYQsYCIBUQsIGIBEQuIWEDEAiIWWBnRHekpKyK6pT+nN2IwryOiE7hkIaId2KOF2k3E28UZ/Yf/hR/a46nNZ5v3YRheAwAAAADgD3wBYVj64yyBjtcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/arrow.png
// module id = phYH
// module chunks = 0